var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

import React from 'react';
import styled, { css } from 'styled-components';
import { classNames } from '../../utils/cn';
var cls = classNames('copyright-privacy-label');
import { breakpoints } from '@shapeable/theme';
import { useLink } from '../../hooks/use-link';
import { useMenu } from '../../hooks/use-menu';
import { usePrivacyPolicyPagePath } from '../../hooks/use-privacy-page-path';
import { useSiteOwnerName } from '../../hooks/use-site-owner-name';
export var CopyrightPrivacyLabelDefaultProps = {
  orgName: 'Shapeable'
}; // -------- Styles -------->

var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  "], ["\n  "])))
}); // -------- Components -------->

var My = {
  Container: styled.p(templateObject_2 || (templateObject_2 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles)
};
export var CopyrightPrivacyLabel = function CopyrightPrivacyLabel(props) {
  var className = props.className;
  var Link = useLink().Link;
  var menu = useMenu();
  var privacyPolicyPagePath = usePrivacyPolicyPagePath();
  var privacyPath = privacyPolicyPagePath || props.privacyPath;
  var siteOwnerName = useSiteOwnerName();
  var orgName = props.orgName || siteOwnerName || '';

  if (!orgName) {
    return null;
  }

  return React.createElement(My.Container, {
    className: cls.name(className)
  }, "\xA9 ", new Date().getFullYear(), " ", orgName, privacyPath && React.createElement(React.Fragment, null, ' - ', React.createElement(Link, {
    onClick: menu.hideOnClick,
    href: privacyPath
  }, "Privacy Policy")));
};
CopyrightPrivacyLabel.defaultProps = CopyrightPrivacyLabelDefaultProps;
CopyrightPrivacyLabel.cls = cls;
var templateObject_1, templateObject_2;